import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

export const staticApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    updateStaticContent: builder.mutation({
      query: (user) => {
        return {
          url: "/admin/add-static-content",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getStaticContent: builder.query({
      query: (user) => {
        return {
          url: "/admin/get-static-content",
          method: "GET",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const { useUpdateStaticContentMutation, useGetStaticContentQuery } =
  staticApi;
